// External
import React, { PureComponent } from 'react';

class Button extends PureComponent {
  render() {
    const { onClick, isDisabled, text } = this.props;
    return (
      <a className={`waves-effect waves-light btn ${isDisabled ? 'disabled' : ''}` }
         onClick={ onClick }
         style={{minWidth: '173px'}}
      >
        { text }
      </a>
    )
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/index.js